import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { PendingApprovalComponent } from './pending-approval/pending-approval.component';
import { MatCardModule } from '@angular/material/card';
import { SharedModule } from 'src/app/shared/shared.module';
import { MatIconModule } from '@angular/material/icon';
import { MatButtonModule } from '@angular/material/button';

const materialModules = [MatCardModule, MatIconModule, MatButtonModule];

@NgModule({
  declarations: [PendingApprovalComponent],
  imports: [CommonModule, SharedModule, ...materialModules],
})
export class PendingApprovalModule {}
